import { render } from "./DiarioAcumulado.vue?vue&type=template&id=b3a6d070"
import script from "./DiarioAcumulado.vue?vue&type=script&lang=js"
export * from "./DiarioAcumulado.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__